/* prettier-ignore */

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ValidIdGuard } from "./guards/valid-id.guard";
import { NewCustomRoutePage } from './pages/new-custom-route/new-custom-route.page';
import { NewSendRoutePage } from './pages/send-update-route/send-update-route.component';
import { LoadFromAPIComponent } from './pages/new-custom-route/load-from-api/load-from-api.component';
import { TechPageComponent } from './pages/send-update-route/tech-page/tech-page.component';
import { Error404Component } from './pages/errors/404/404.component';
import { RegisterStandaloneComponent } from './pages/register-standalone/register-standalone.page';
import { InfoRouteComponent } from './pages/info-route/info-route.component';
import { NewDetailsPage } from './pages/new-details/new-details.page';
import { SurveyComponent } from './pages/new-survey/new-survey.component';
import { AuthGuard } from './auth/auth.guard';

const routes: Routes = [  
  { path: 'custom-route', data: { animation: 'routePage' }, loadComponent: () => NewCustomRoutePage },
  { path: 'custom-route/:id', loadComponent: () => LoadFromAPIComponent },
  { path: 'tech-edit/:id', loadComponent: () => LoadFromAPIComponent },
  { path: 'send-update-route', data: { animation: 'sendPage' }, loadComponent: () => NewSendRoutePage },
  { path: 'info-route', data: { animation: 'sendPage' }, loadComponent: () => InfoRouteComponent },
  { path: 'save-recommended-route', data: { animation: 'saveRoutePage' }, loadComponent: () => TechPageComponent },
  { path: 'tech-register-by-token/:token', data: { animation: 'registerStandaloneByToken' }, loadComponent: () => RegisterStandaloneComponent },
  { path: 'tech-register-by-id/:id', data: { animation: 'registerStandaloneById' }, loadComponent: () => RegisterStandaloneComponent },
  { path: 'survey-id/:id', data: { animation: 'SurveyComponentByID' }, loadComponent: () => SurveyComponent },
  { path: 'survey-id/:id/:lang', data: { animation: 'SurveyComponentByIDLang' }, loadComponent: () => SurveyComponent },
  { path: 'event/:name/:itemId', data: { animation: 'eventDetailsPage' }, loadComponent: () => NewDetailsPage },
  { path: 'point/:name/:itemId', data: { animation: 'pointDetailsPage' }, loadComponent: () => NewDetailsPage },
  { path: 'hiking/:name/:itemId', data: { animation: 'hikingDetailsPage' }, loadComponent: () => NewDetailsPage },
  { path: "not-found", data: { animation: 'notFoundPage' }, loadComponent: () => Error404Component },
  
  { path: 'home', data: { animation: 'homePage' }, loadChildren: () => import('./pages/home/home.module').then( m => m.HomePageModule) },
  { path: 'my-account', data: { animation: 'myAccountPage' }, loadChildren: () => import('./pages/my-account/my-account.module').then( m => m.MyAccountModule), canActivate: [AuthGuard] },
  { path: 'register-user', data: { animation: 'registerPage' }, loadChildren: () => import('./pages/register-user/register-user.module').then( m => m.RegisterUserPageModule) },
  { path: ":name/:id", data: { animation: 'categoriesPage' }, canActivate: [ValidIdGuard], loadChildren: () => import("./pages/categories-list/categories-list.module").then((m) => m.CategoriesListPageModule) },
  { path: "events", data: { animation: 'eventsPage' }, loadChildren: () => import("./pages/categories-list/categories-list.module").then((m) => m.CategoriesListPageModule) },
  { path: "hikings", data: { animation: 'hikingsPage' }, loadChildren: () => import("./pages/categories-list/categories-list.module").then((m) => m.CategoriesListPageModule) },
  { path: "offers", data: { animation: 'offersPage' }, loadChildren: () => import("./pages/categories-list/categories-list.module").then((m) => m.CategoriesListPageModule) },

  { path: "", redirectTo: "home", pathMatch: "full" },
  { path: "**", redirectTo: "not-found" },
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [RouterModule]
})

export class AppRoutingModule { }